class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', () => this.onFocusOut());
    this.mainDetailsToggle.addEventListener('toggle', () => this.onToggle());
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.megaMenu = this.mainDetailsToggle.classList.contains('mega-menu');
    this.hoverMedia = window.matchMedia('(min-width: 990px)');
    this.closeTimeout = null;
    this.summary = this.mainDetailsToggle.querySelector('summary');

    if (this.megaMenu) {
      this.onHoverOpen = this.onHoverOpen.bind(this);
      this.onHoverClose = this.onHoverClose.bind(this);
      this.onSummaryClick = this.onSummaryClick.bind(this);
      this.hoverMedia.addEventListener('change', this.onHoverMediaChange.bind(this));
      this.summary.addEventListener('click', this.onSummaryClick);
      this.onHoverMediaChange();
    }
  }

  onHoverMediaChange() {
    if (!this.megaMenu) return;

    if (this.hoverMedia.matches) {
      this.addEventListener('mouseenter', this.onHoverOpen);
      this.addEventListener('mouseleave', this.onHoverClose);
    } else {
      this.clearCloseTimeout();
      this.removeEventListener('mouseenter', this.onHoverOpen);
      this.removeEventListener('mouseleave', this.onHoverClose);
    }
  }

  onSummaryClick(event) {
    if (!this.megaMenu || !this.hoverMedia.matches) return;
    event.preventDefault();
  }

  onFocusOut() {
    if (this.megaMenu && this.hoverMedia.matches) return;
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  clearCloseTimeout() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  closeOtherMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this || !menu.mainDetailsToggle?.classList.contains('mega-menu')) return;
      menu.clearCloseTimeout();
      menu.close();
    });
  }

  onHoverOpen() {
    if (!this.hoverMedia.matches) return;
    this.clearCloseTimeout();
    this.closeOtherMenus();
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onHoverClose(event) {
    if (!this.hoverMedia.matches) return;

    const relatedTarget = event.relatedTarget;
    if (relatedTarget && this.contains(relatedTarget)) return;

    this.clearCloseTimeout();
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 200);
  }

  close() {
    this.clearCloseTimeout();
    super.close();
  }

  onToggle() {
    super.onToggle();

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
